import { mergeStyleSets } from '@uifabric/merge-styles';

export default mergeStyleSets({
  root: {
    position: 'relative',
  },
});
